export default {
  1: { label: 'Business' },
  2: { label: 'Billing' },
  3: { label: 'Connect Accounts' },
  4: { label: 'Complete', hidden: true },
};
